import isSSR from '@calm/web-common/dist/isSSR';
import { datadogRum } from '@datadog/browser-rum-slim';
import { getDatadogConfig } from '../config';
import beforeSend from './before-send';

export const initDatadogRum = (): void => {
    const datadogConfig = getDatadogConfig(process.env.NEXT_PUBLIC_ENV);
    if (datadogConfig.env === 'local' || isSSR()) {
        return;
    }
    datadogRum.init({
        ...datadogConfig,
        trackUserInteractions: false,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend,
    });
};
